package com.neurobs.react.semanticui

import com.neurobs.react.{ElementModifiers, ReactUtil}
import slinky.core.facade.ReactElement
import slinky.web.html._

object UiTableFactory {

  private def TemplateTable(children: ReactElement*)(uiElementModifiers: UiElementModifiers) = {
    table(
      className := uiElementModifiers.formattedClassName("table"),
      style := uiElementModifiers.createStyle
    )(
      children:_*
    )
  }

  def Table(children: ReactElement*)(implicit uiElementModifiers: UiElementModifiers) = {
    TemplateTable(children)(uiElementModifiers)
  }
}
